"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var CompressedfileIcon = function CompressedfileIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "icon/compressedfile"), /*#__PURE__*/React.createElement("g", {
    id: "OCR",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/compressedfile"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: "0",
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4",
    transform: "translate(2.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#000000",
    opacity: "0.25",
    x: "0",
    y: "0",
    width: "15",
    height: "15",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62\u5907\u4EFD",
    fill: "#FFFFFF",
    x: "5.5",
    y: "8",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62\u5907\u4EFD-4",
    fill: "#FFFFFF",
    x: "7.5",
    y: "6",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62\u5907\u4EFD-5",
    fill: "#FFFFFF",
    x: "5.5",
    y: "4",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62\u5907\u4EFD-6",
    fill: "#FFFFFF",
    x: "7.5",
    y: "2",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62\u5907\u4EFD-7",
    fill: "#FFFFFF",
    x: "5.5",
    y: "0",
    width: "2",
    height: "2"
  })))));
};
var _default = CompressedfileIcon;
exports["default"] = _default;